import React from 'react';

const InfoText = ({title, infoText, quote, files}) => {
  return (
    <div className="map-info-text">
      <h2>{title}</h2>
      <p>{infoText}</p>
      <div className="quote">
        {quote !== '""' &&
          <>
            <div className="divider" />
            <i>{quote}</i>
          </>
        }
        <div className="divider" />
      </div>
      <div className="downloads">
      {files &&
        <>
        {files.map(file => (
          <a href={file.file.url} key={file.file.url} target="_blank" rel="noopener noreferrer">{file.file.description && file.file.description} {file.file.fileName}</a>
        ))}
        <div className="divider"/>   
        </>
      }
      </div>
    </div>
  );
};

export default InfoText;